const version = "0.0.0";
const buildTime = Date.now();
const env = (
  import.meta as unknown as {
    env: {
      NODE_ENV: string;
      VITE_APP_API_HOST: string;
      VITE_APP_LOG_LEVEL: string;
      VITE_APP_ENV: string;
      VITE_APP_ID_INTERCOM: string;
      VITE_APP_STRIPE: string;
      VITE_APP_AMPLITUDE_API_KEY: string;
      VITE_APP_SINGULAR_API_KEY: string;
      VITE_APP_SINGULAR_API_SECRET: string;
      VITE_APP_PARTNER_ID: string;
      VITE_APP_DD_CLIENT_TOKEN: string;
      VITE_APP_DD_APPLICATION_ID: string;
      VITE_APP_SHA?: string;
    };
  }
).env;

export const config = {
  apiHost: env.VITE_APP_API_HOST as string,
  remoteLoggingLevel: env.VITE_APP_LOG_LEVEL as string,
  environment: env.NODE_ENV as string,
  intercomId: env.VITE_APP_ID_INTERCOM as string,
  stripePublishableKey: env.VITE_APP_STRIPE as string,
  appEnv: env.VITE_APP_ENV as string,
  amplitudeKey: env.VITE_APP_AMPLITUDE_API_KEY as string,
  singular: {
    key: env.VITE_APP_SINGULAR_API_KEY as string,
    secret: env.VITE_APP_SINGULAR_API_SECRET as string
  },
  partnerId:
    !env.VITE_APP_PARTNER_ID || env.VITE_APP_PARTNER_ID === "-1"
      ? undefined
      : (env.VITE_APP_PARTNER_ID as string),
  version,
  buildTime,
  datadog: {
    clientToken: env.VITE_APP_DD_CLIENT_TOKEN as string,
    applicationId: env.VITE_APP_DD_APPLICATION_ID as string
  },
  buildId: env.VITE_APP_SHA || "local"
};
